// Detects whether the app is running inside a native Capacitor shell (iOS/Android).
// Uses the runtime-injected global so the web build needs no Capacitor dependency.
export const isNativePlatform = (): boolean => {
  const cap = (window as any).Capacitor;
  return !!(cap && typeof cap.isNativePlatform === 'function' ? cap.isNativePlatform() : cap?.isNative);
};

export const getPlatform = (): string => {
  const cap = (window as any).Capacitor;
  if (cap && typeof cap.getPlatform === 'function') return cap.getPlatform();
  return 'web';
};
